import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SystemSalaryMiniEntity } from '../../domain/entities/SystemSalaryMiniEntity'
import type { SalarySystemListedAdminDto } from '@/backend/market'

export class SystemSalaryMiniModel extends SystemSalaryMiniEntity {
  constructor(dataDto: SalarySystemListedAdminDto) {
    super()
    mapEntityProperties<SystemSalaryMiniEntity>(this, dataDto)
  }
}
